import { ReactElement } from 'react';

import { Directions } from '@cashier/cashier-model';
import { AmountConverter } from '@cashier/cashier-shared';
import { cn } from '@cashier/cashier-ui';

import styles from './styles.module.scss';

interface TextRowProperties {
  label: string;
  value: string;
  direction: Directions;
}

export const TextRow = ({
  label,
  value,
  direction,
}: TextRowProperties): ReactElement => {
  const [text, code] = String(value).split(':');

  const convertToReadableValue = (value: string): string => {
    return Number.isFinite(parseFloat(value))
      ? AmountConverter.exponentialNotationToNumber(value)
      : value;
  };

  if (label && direction === Directions.Ltr) {
    return (
      <div className={styles.container}>
        <div
          className={cn([styles.text, styles.leftColumn])}
          data-test="left-column"
        >
          {label}:
        </div>
        <div
          className={cn([styles.text, styles.rightColumn])}
          data-test="right-column"
        >
          {convertToReadableValue(text)}
          {code && <span className={styles.code}>{`: ${code}`}</span>}
        </div>
      </div>
    );
  }

  if (label && direction === Directions.Rtl) {
    return (
      <div className={styles.container}>
        <div
          className={cn([styles.text, styles.leftColumn])}
          data-test="left-column"
        >
          {convertToReadableValue(text)}
          {code && <span className={styles.code}>{`: ${code}`}</span>}
        </div>
        <div
          className={cn([styles.text, styles.rightColumn])}
          data-test="right-column"
        >
          {label}:
        </div>
      </div>
    );
  }

  return (
    <div className={cn([styles.text, styles.codeRow])}>
      {convertToReadableValue(text)}
      {code && <span className={styles.code}>{`: ${code}`}</span>}
    </div>
  );
};
